function separateElements( els, compare ){
	var out = [[], []];
	for(var i=0,j=els.length;i<j;i++){
		if ( compare(els[i]) ){
			out[1].push(els[i]);
		}
		else {
			out[0].push(els[i]);
		}
	}
	return out;
}

module.exports = separateElements;